import React from "react";
import AspectShapeIcon, { shapeFromAspect } from "../../../shared/AspectShapeIcon";
import "./ResizePresetIcon.css";

/**
 * Same AspectShapeIcon geometry as AI Expand (shape only — brand logos render under the card text).
 */
export default function ResizePresetIcon({
  width,
  height,
  aspectRatio,
  size = 36,
  className = "",
}) {
  const shape = shapeFromAspect(width, height, aspectRatio);
  const iconSize = size || 36;

  return (
    <span
      className={`resize-preset-icon${className ? ` ${className}` : ""}`}
      aria-hidden="true"
    >
      <AspectShapeIcon
        shape={shape}
        size={iconSize}
        className="resize-preset-icon__frame"
      />
    </span>
  );
}

/**
 * Pixel dims only for cards: "1080 × 1080" (aspect goes on the next line).
 */
export function formatPresetDims(preset) {
  const w = Number(preset?.width);
  const h = Number(preset?.height);
  if (Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) {
    return `${w} × ${h}`;
  }
  const fromLabel = String(preset?.dims_label || preset?.dimensions || "").trim();
  const match = fromLabel.match(/(\d+)\s*[×x]\s*(\d+)/i);
  if (match) return `${match[1]} × ${match[2]}`;
  return fromLabel;
}

/**
 * Second card line: metadata label + aspect in brackets, e.g. "Square (1:1)".
 */
export function formatPresetMetaLine(preset) {
  const label = String(preset?.label || preset?.shape_label || "").trim();
  const ar = String(preset?.aspect_ratio || "").trim();
  if (label && ar) return `${label} (${ar})`;
  if (ar) return `(${ar})`;
  return label;
}
